// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Registro de Amigo',
  intro:
    'Cada solicitud que Amigo gestionó: qué se pidió, dónde, quién lo pidió y quién lo aprobó. Solo FoodAmigos ve esta página.',
  // The tab list's name for screen readers.
  tabs_label: 'Registro de Amigo',
  tabs: {
    requests: 'Solicitudes',
    gaps: 'No se pudo hacer',
  },
  filters: {
    restaurant: 'Restaurante',
    all_restaurants: 'Todos los restaurantes',
    brand: '{{name}} · Marca',
    restaurant_unknown: 'Restaurante {{id}}',
    searching: 'Buscando restaurantes…',
    no_restaurant: 'No hay ningún restaurante llamado «{{query}}»',
    period: 'Periodo',
    start_date: 'Fecha de inicio',
    end_date: 'Fecha de fin',
    refresh: 'Actualizar',
    gap: 'Pidió: {{request}}',
    change_set: 'La solicitud detrás de un cambio',
    remove: 'Quitar el filtro: {{label}}',
    clear: 'Borrar filtros',
  },
  columns: {
    steps: 'Pasos',
    when: 'Cuándo',
    request: 'Solicitud',
    restaurant: 'Restaurante',
    asked_by: 'Pedido por',
    result: 'Resultado',
  },
  show_steps: 'Mostrar los pasos de: {{request}}',
  approved_by: 'Aprobado por {{name}}',
  nothing_approved: 'Nada aprobado',
  results: {
    applied: '{{applied}} aplicados',
    applied_skipped: '{{applied}} aplicados · {{skipped}} omitidos',
    partial: '{{applied}} de {{total}} aplicados',
    imported: 'Importado',
    importing: 'Importando',
    waiting: 'Esperando aprobación',
    rejected: 'Rechazado',
    undone: 'Deshecho',
    expired: 'Caducado',
    replaced: 'Reemplazado',
    failed: 'Fallido',
    answered: 'Respondido',
    not_yet: 'Aún no se pudo hacer',
    off_limits: 'Fuera de alcance',
    not_allowed: 'No permitido',
    switched_off: 'Desactivado',
    guard: 'Detenido por una comprobación de seguridad',
    not_found: 'No encontrado',
  },
  steps: {
    asked: '{{name}} preguntó',
    asked_anonymous: 'Solicitudes',
    approved: 'Aprobado por {{name}}',
    approved_alone: 'Aprobado',
    applied_one: '{{count}} cambio aplicado',
    applied_other: '{{count}} cambios aplicados',
    failed_one: '{{count}} no aplicados',
    failed_other: '{{count}} no aplicados',
    rejected: 'Rechazado',
    undone: 'Deshecho',
    skipped_one: '{{count}} omitidos',
    skipped_other: '{{count}} omitidos',
    skipped_state: 'Omitido',
    more_one: 'y {{count}} más',
    more_other: 'y {{count}} más',
    changes_one: '{{count}} cambio',
    changes_other: '{{count}} cambios',
    other: 'Comprobando algo',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} paso',
    steps_other: '{{count}} pasos',
    refused_one: '{{count}} rechazados',
    refused_other: '{{count}} rechazados',
    failed_one: '{{count}} fallidos',
    failed_other: '{{count}} fallidos',
  },
  // A request that changed nothing says what came of it, under Result (design: Log · steps open).
  outcomes: {
    title: 'Resultado',
    answered: 'Una respuesta: no se cambió nada.',
    waiting: 'Esperando aprobación. Aún no se ha cambiado nada.',
    rejected: 'Rechazado: no se cambió nada.',
    expired: 'Caducó sin aprobación: no se cambió nada.',
    replaced: 'Sustituido por una tarjeta más reciente: aquí no se cambió nada.',
    undone: 'Deshecho: se revirtieron los cambios.',
    failed: 'Error: no se cambió nada.',
    not_yet: 'Aún no se pudo hacer: no se cambió nada. Contado en No se pudo hacer.',
    off_limits: 'Fuera de los límites: no se cambió nada.',
    not_allowed: 'No permitido para el rol de esta persona: no se cambió nada.',
    switched_off: 'Desactivado aquí: no se cambió nada.',
    guard: 'Detenido por una comprobación de seguridad: no se cambió nada.',
    not_found: 'No encontrado: no se cambió nada.',
    importing: 'Importando. Cada plato se guarda en Menú → Historial de ediciones.',
    imported: 'Importado. Cada plato está en Menú → Historial de ediciones.',
  },
  changes: {
    // With where they were made: "3 changes · Hilltop Burger · Ehrenfeld".
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} cambio',
    title_other: '{{count}} cambios',
    show_all: 'Mostrar los {{count}} cambios',
    show_fewer: 'Mostrar menos',
    from: 'de',
    to: 'a',
    removed: 'Eliminado',
  },
  row_states: {
    skipped: 'Omitido',
    failed: 'No aplicado',
    stale: 'Cambiado mientras tanto',
    kept: 'Se deja como está',
  },
  menu_history: 'Abrir Menú → Historial de ediciones',
  // Opens the request's chat in the Amigo panel, on its restaurant (read only when someone else started it).
  open_chat: 'Abrir el chat',
  // Both links first switch the dashboard to the request's restaurant; this says that didn't work.
  switch_failed: 'No se pudo abrir ese restaurante. Inténtalo de nuevo.',
  pagination: {
    label: 'Páginas',
    summary: '{{from}}–{{to}} de {{total}} solicitudes',
    previous: 'Página anterior',
    next: 'Página siguiente',
  },
  empty: {
    title: 'Sin solicitudes para {{restaurant}} en este periodo',
    text: 'Amigo no ha gestionado nada allí entre {{from}} y {{to}}.',
    title_any_day: 'Aún no hay solicitudes para {{restaurant}}',
    text_any_day: 'Amigo aún no ha gestionado nada allí.',
    title_everywhere: 'Sin solicitudes en este periodo',
    text_everywhere: 'Amigo no ha gestionado nada entre {{from}} y {{to}}.',
    title_nothing: 'Aún no hay solicitudes',
    text_nothing: 'Amigo aún no ha gestionado nada.',
  },
  loading: 'Cargando…',
  error: {
    title: 'No se pudo cargar el registro',
    text: 'Inténtalo de nuevo en un momento.',
    retry: 'Inténtalo de nuevo',
  },
  gaps: {
    intro:
      'Lo que Amigo aún no pudo hacer, agrupado por lo que se pidió, de más a menos solicitado. Las solicitudes fuera de alcance y las que un rol no permite no aparecen aquí.',
    columns: {
      area: 'Área',
      request: 'Lo que pidió la gente',
      count: 'Solicitudes',
      last_at: 'Última solicitud',
      requests: 'Solicitudes',
    },
    count: '{{count}}×',
    see_requests_one: 'Ver {{count}} solicitud',
    see_requests_other: 'Ver {{count}} solicitudes',
    today: 'Hoy, {{time}}',
    yesterday: 'Ayer, {{time}}',
    empty_title: 'Ninguna solicitud que Amigo no pudiera atender',
    empty_text: 'Amigo pudo atender todo lo que le pidieron.',
  },
  areas: {
    menu: 'Menú',
    hours: 'Horario de apertura',
    order_settings: 'Ajustes de pedidos',
    my_info: 'Mi información',
    marketing: 'Marketing',
    gift_cards: 'Tarjetas regalo',
    reports: 'Informes',
    website: 'Sitio web',
    integrations: 'Integraciones',
    delivery: 'Reparto',
    payments: 'Pagos',
    team: 'Equipo',
    billing: 'Facturación',
    settings: 'Ajustes',
    other: 'Otros',
  },
};
